import { createContext, useContext } from 'react';

/**
 * Size of the chip-bar controls. `compact` is the RingilDataTable v3 bar (Figma 21940:60909): every
 * chip and the "All filters" button share one 24px height with 12px text. Provided by FilterBarV2 for
 * its own row only, so the chips in the "All filters" sidebar keep their size.
 *
 * In its own module (not next to a component) so hot reload doesn't recreate the context.
 */
export type FilterBarDensity = 'default' | 'compact';

export const FilterBarDensityContext = createContext<FilterBarDensity>('default');

export const useFilterBarDensity = (): FilterBarDensity => useContext(FilterBarDensityContext);

/** Box of a chip: height, horizontal padding and type size. */
export const chipBoxClass = (density: FilterBarDensity): string => (density === 'compact' ? 'h-6 px-2 py-0 text-xs' : 'px-2 py-1 text-base');

/** Padding of the visible content inside a chip that overlays a native select (Select / Sort chips). */
export const chipContentPadding = (density: FilterBarDensity): string => (density === 'compact' ? 'px-2 py-0' : 'px-2 py-1');

/** Type size of a chip whose box is sized by its content (Select / Sort chips). */
export const chipTextClass = (density: FilterBarDensity): string => (density === 'compact' ? 'h-6 text-xs' : 'text-base');
